const firebaseConfig = {
  apiKey: "AIzaSyASG0A6vUBRedZvACmCJnt149b9Pv0Os3k",
  authDomain: "mogged-mvp.firebaseapp.com",
  databaseURL: "https://mogged-mvp-default-rtdb.firebaseio.com",
  projectId: "mogged-mvp",
  storageBucket: "mogged-mvp.appspot.com",
  messagingSenderId: "903933903936",
  appId: "1:903933903936:web:07b957bddfd899d5f5cba5",
  measurementId: "G-0D1TD08TRC",
  // App Check reCAPTCHA v3 site key (public, safe to commit). Empty = App
  // Check init is skipped. Fill after registering the app in the Firebase
  // console (App Check → reCAPTCHA v3). See src/firebase/Init.js.
  appCheckSiteKey: "6Lc0tkctAAAAALJNwkObYBGwpt2IDyHfALuweCmY"
};
export default firebaseConfig;
